module.exports = __webpack_public_path__ + "static/pt-moa-graphic-desktop-2fc5e4a22892807f6adb98d7c7c21b47.png";